export default {
  "TopContents.DisplayAgreementDetail":
    "ご自身のデータの取り扱いに関する同意事項の確認はこちら",
  "TopContents.DisplayAgreementLinkText": "「同意事項一覧」へ",
  "TopContents.NoticeConfigCardDetail": "お知らせ、メルマガの受信設定はこちら",
  "TopContents.NoticeConfigCardLinkText": "「お知らせ配信の設定」へ",
  "TopContents.ThirdPartyDetail":
    "ご自身のデータの提供先と種類の確認・変更はこちら",
  "TopContents.ThirdPartyLinkText": "「第三者提供の管理」へ",
  "TopContents.LocationManagementDetail":
    "ご自身の位置情報の利用に関する同意状況の確認・変更はこちら",
  "TopContents.LocationManagementLinkText": "「位置情報利用の管理」へ",
  "TopContents.AccountLinkageDetail":
    "ビジネスdアカウントの連携サービスの変更はこちら",
  "TopContents.AccountLinkageLinkText": "「連携サービス一覧」へ",
}
